import { useCallback, useRef } from 'react';

/**
 * Whether an async result still belongs to the input it was requested for
 * (e.g. the restaurant or reservation shown when the request started), so a
 * slower answer for a previous one never overwrites the current view.
 */
export default function useStillCurrent(input: string) {
  const current = useRef(input);
  current.current = input;
  return useCallback((requestedFor: string) => current.current === requestedFor, []);
}
